import { CURRENCY_FORMAT } from 'constants/currency';

export const DEFAULT_PRICE = '-';

export const formatPrice = ({ amount, symbol }) => {
  if (!parseFloat(amount) || !symbol) {
    return DEFAULT_PRICE;
  }

  if (symbol === CURRENCY_FORMAT.VND.symbol) {
    return `${amount}${symbol}`;
  }

  return `${symbol}${amount}`;
};

export const isNegativeAmount = amount =>
  !!amount && amount.toString().startsWith('-');

export const absAmount = amount =>
  amount ? amount.toString().replace(/-/, '') : amount;

export default {};
